import { IntlShape } from 'react-intl';

export const getPlanName = (count: number, intl: IntlShape) => {
  switch (count) {
    case 1:
      return intl.formatMessage({
        id: 'subscription.plan.name.month',
        defaultMessage: 'Місячний',
      });
    case 3:
      return intl.formatMessage({
        id: 'subscription.plan.name.quarterly',
        defaultMessage: 'Квартальний',
      });
    case 6:
      return intl.formatMessage({
        id: 'subscription.plan.name.half',
        defaultMessage: 'Піврічний',
      });
  }
};
